<template>
  <div style="padding: 10px 30px; background: white">
    <v-overlay v-if="syncing" z-index="998">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <div v-if="isThankyouPage == false">
      <p v-if="order" style="text-align: center">
        <strong>Hello {{ order.order_billing.first_name }}!</strong>
      </p>
      <p v-if="order" style="text-align: center">
        You've recently bought
        <strong style="color: steelblue">
          {{ products[productCount].title }}</strong>
        at our store, what do you think about it?
      </p>

      <v-row>
        <v-col class="text-center d-flex flex-column align-center justify-center">
          <v-img :src="products[productCount].image" width="150px" alt="Your Purchased Product">
          </v-img>
        </v-col>
      </v-row>

      <p style="text-align: center">
        Write a review, We would love to hear from you about this product :).
      </p>
      <form>
        <table style="width: 100%">
          <tbody>
            <tr>
              <td style="text-align: center; line-height: 40px">
                <span style="
                    padding: 0px;
                    white-space: nowrap;
                    display: inline-block;
                  ">
                  <label>
                    <input type="radio" name="ratingIndicator" value="5" v-model="review.rating"
                      style="float: left; margin: 5px" />
                    <span style="color: #ffd700; font-size: 19px; line-height: 23px">
                      <img style="height: 22px"
                        src="https://firebasestorage.googleapis.com/v0/b/orders-union.appspot.com/o/uploads%2F5stars.png?alt=media&token=39f823dd-dd5b-4083-a100-3e5906c1bf44"
                        class="CToWUd" />
                    </span>
                  </label>
                </span>
                <span style="
                    padding: 0px;
                    white-space: nowrap;
                    display: inline-block;
                  ">
                  <label>
                    <input type="radio" name="ratingIndicator" value="4" v-model="review.rating"
                      style="float: left; margin: 5px" />
                    <span style="color: #ffd700; font-size: 19px; line-height: 23px">
                      <img style="height: 20px"
                        src="https://firebasestorage.googleapis.com/v0/b/orders-union.appspot.com/o/uploads%2Funnamed.png?alt=media&token=fcd4179e-943c-49e8-b615-726bd6231628"
                        class="CToWUd" />
                    </span>
                  </label>
                </span>
                <span style="
                    padding: 0px;
                    white-space: nowrap;
                    display: inline-block;
                  ">
                  <label>
                    <input type="radio" name="ratingIndicator" value="3" v-model="review.rating"
                      style="float: left; margin: 5px" />
                    <span style="color: #ffd700; font-size: 19px; line-height: 23px">
                      <img style="height: 20px"
                        src="https://firebasestorage.googleapis.com/v0/b/orders-union.appspot.com/o/uploads%2F3stars.png?alt=media&token=cc2cfda8-8a4d-4e00-a931-0a0d271d7497"
                        class="CToWUd" />
                    </span>
                  </label>
                </span>
                <span style="
                    padding: 0px;
                    white-space: nowrap;
                    display: inline-block;
                  ">
                  <label>
                    <input type="radio" name="ratingIndicator" value="2" v-model="review.rating"
                      style="float: left; margin: 5px" />
                    <span style="color: #ffd700; font-size: 19px; line-height: 23px">
                      <img style="height: 20px"
                        src="https://firebasestorage.googleapis.com/v0/b/orders-union.appspot.com/o/uploads%2F2stars.png?alt=media&token=682f5cd3-3f93-49b6-908d-aa12dd84521c"
                        class="CToWUd" />
                    </span>
                  </label>
                </span>
                <span style="
                    padding: 0px;
                    white-space: nowrap;
                    display: inline-block;
                  ">
                  <label>
                    <input type="radio" name="ratingIndicator" value="1" v-model="review.rating"
                      style="float: left; margin: 5px" />
                    <span style="color: #ffd700; font-size: 19px; line-height: 23px">
                      <img style="height: 20px"
                        src="https://firebasestorage.googleapis.com/v0/b/orders-union.appspot.com/o/uploads%2F1star.png?alt=media&token=12c56e94-db65-4a76-91bf-7ed876c0330e"
                        class="CToWUd" />
                    </span>
                  </label>
                </span>
              </td>
            </tr>

            <tr>
              <td>
                <br />
                How was your overall experience using the item? <span>*</span>
              </td>
            </tr>
            <tr>
              <td>
                <textarea name="reviewMessage" rows="5" cols="75" v-model="review.description" style="
                    font-size: 1em;
                    padding-left: 3px;
                    min-height: 60px;
                    width: 100%;
                    border: solid 1px #bababa;
                    font-family: inherit;
                  "></textarea>
              </td>
            </tr>
          </tbody>
        </table>
        <v-btn v-if="reviewMediaList.length == 0" color="primary" @click="uploadDialog = true">Upload Feedback
          File</v-btn>
        <div>
          <v-row>
            <v-col cols="1" v-for="img in reviewMediaList" :key="img">
              <v-avatar color="surface-variant"><v-img :src="img.link" alt="Feedback image"></v-img></v-avatar>
            </v-col>
          </v-row>
        </div>
        <v-btn @click="createReview()" style="
            background-color: #0b9444;
            background: #0b9444;
            color: #ffffff;
            padding: 9px 22px;
            height: initial;
            font-size: 14px;
            font-weight: bold;
            border: none;
            border-radius: 4px;
            margin: 35px auto;
            display: block;
          ">
          Submit Review
        </v-btn>
      </form>
      <!--UPLOAD DIALOG-->
      <v-dialog @click:outside="closeDialog" max-width="450px" v-model="uploadDialog">
        <v-card @drop="onDrop($event)" @dragover.prevent="dragover = true" @dragenter.prevent="dragover = true"
          @dragleave.prevent="dragover = false" :class="{ 'grey lighten-2': dragover }">
          <v-card-text>
            <v-row class="d-flex flex-column" dense align="center" justify="center">
              <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
                mdi-cloud-upload
              </v-icon>
              <p>Drop your file(s) here, or <a @click="$refs.fileInput.click()">click</a> to select them.</p>
              <input ref="fileInput" accept="image/*, video/*" type="file" style="display: none"
                @change="getInputSelectFiles" multiple />
            </v-row>
            <v-virtual-scroll v-if="uploadedFiles.length > 0" :items="uploadedFiles" height="150" item-height="50">
              <template v-slot:default="{ item }">
                <v-list-item :key="item.name">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.name }}
                      <span class="ml-3 text--secondary">
                        {{ item.size }} bytes</span>
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn @click.stop="removeFile(item.name)" icon>
                      <v-icon> mdi-close-circle </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-divider></v-divider>
              </template>
            </v-virtual-scroll>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="closeDialog" color="secondary"> Cancel </v-btn>

            <v-btn @click="getFeedbackFiles" :disabled="uploadedFiles.length == 0" color="primary">
              Upload
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-if="isThankyouPage" style="text-align: center">
      <h1 style="font-size: 100px">THANK YOU</h1>
      <h2 style="font-size: 50px">FOR YOUR TIME</h2>
      <h3 style="font-size: larger">
        Enjoy a discount of {{ discount }}% on your next purchase with a coupon code:
        <b>{{discountCode}}</b>
      </h3>
    </div>
    <!--SNACKBAR FOR ERRORS-->
    <v-snackbar v-model="snackbar">
      {{ snackBarText }}

      <template>
        <v-btn color="secondary" text @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { BASE_URL } from "./baseUrl";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

export default {
  name: "FeedbackView",
  data() {
    return {
      orderId: "",
      productId: "",
      order: null,
      productDetail: "",
      snackbar: false,
      snackBarText: "",
      products: [],
      productCount: 0,
      uploadDialog: false,
      dragover: false,
      uploadedFiles: [],
      multiple: false,
      review: {
        rating: 0,
        description: "",
        product_id: 0,
        review_id: 0,
      },
      reviewMedia: {
        review_id: 0,
        link: "",
      },
      reviewMediaList: [],
      options: {
        headers: {
          "Access-Control-Allow-Headers":
            "X-Custom-Header, Access-Control-Request-Headers",
          //"x-access-token": localStorage.getItem("token"),
          //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
        },
      },
      storageRef: null,
      file: null,
      syncing: false,
      isThankyouPage: false,
      isMedia: false,
      discountCode: "",
      discount: 5
    };
  },
  mounted() {
    this.orderId = this.$route.query.orderId;


    var url = BASE_URL + `orders/orderWithProductReviews?orderId=${this.orderId}`;
    axios
      .get(url, this.options)
      .then((response) => {
        console.log(response);
        this.order = response.data;

        const reviewedProductIds = this.order.review?.review_products.map(rp => rp.product_id.toString());
        this.products = this.order.order_products.filter(product => !reviewedProductIds?.includes(product.product_id));
        if (this.products == null || this.products.length == 0) {
          this.isThankyouPage = true;
        } else {
          this.productCount = 0;
        }

      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {

    createReview() {
      this.review.review_id = this.order.review.id;
      this.review.product_id = this.products[this.productCount].product_id;
      let newReview = {
        isCompleted: false,
        review: this.review,
        media: this.reviewMediaList,
        isMedia: this.isMedia
      };
      if (this.products.length == this.productCount + 1) {
        // route to thank you page
        this.isThankyouPage = true;
        newReview.isCompleted = true;
      }
      console.log(newReview);
      var url = BASE_URL + `reviews/`;
      axios
        .post(url, newReview, this.options)
        .then((response) => {
          console.log(response);
          if (response.data.hasError == false) {
            //this.snackbar = true;
            //this.snackBarText = response.data.message;
            if(newReview.isCompleted){
              this.discountCode = response.data.message
              if(this.isMedia){
                this.discount = 10
              }
            }
            this.review.description = "";

            this.productCount += 1;
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
      console.log(this.review);
    },
    getInputSelectFiles() {
      //console.log(event.target.files.length)
      var selectedFiles = event.target.files
      for (var i = 0; i < selectedFiles.length; i++) {
        this.uploadedFiles.push(selectedFiles[i])
      }
      console.log(this.uploadedFiles)
    },
    getFeedbackFiles() {
      //this.file = event.target.files[0];
      console.log(this.uploadedFiles);
      this.upload();
    },

    upload() {
      if(this.uploadedFiles.length > 0){
        this.isMedia = true;
      }
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        this.file = this.uploadedFiles[i];
        this.syncing = true;
        const storage = getStorage();
        const storageRef = ref(storage, "images/" + this.file.name);
        const uploadTask = uploadBytesResumable(storageRef, this.file);

        uploadTask.on("state_changed", null, null, () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            var link = downloadURL;
            console.log(link);
            this.syncing = false;
            var media = {
              review_id: this.order.review.id,
              link: link,
              product_id: this.products[this.productCount].product_id,
            };
            this.reviewMediaList.push(media);
          });
        });
      }
      this.uploadDialog = false;
    },
    closeDialog() {
      this.uploadDialog = false;
      this.uploadedFiles = [];
    },
    onDrop(e) {
      e.preventDefault();
      if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
      console.log(e.dataTransfer.files);
      var selectedFiles = e.dataTransfer.files;
      this.dragover = false;
      for (var i = 0; i < selectedFiles.length; i++) {
        this.uploadedFiles.push(selectedFiles[i]);
      }
    },
    removeFile(fileName) {
      const index = this.uploadedFiles.findIndex(
        (file) => file.name === fileName
      );
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
    },
  },
};
</script>

<style scoped></style>